// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var HhsPhoneType;
(function (HhsPhoneType) {
    HhsPhoneType["Home"] = "home";
    HhsPhoneType["Mobile"] = "mobile";
    HhsPhoneType["Work"] = "work";
})(HhsPhoneType || (HhsPhoneType = {}));
//# sourceMappingURL=hhsPhoneType.js.map